module.exports = __webpack_public_path__ + "static/media/platinum-partner1.4056bd51.png";